import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { userStore } from 'stores/global/RootStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import MenuItem from './MenuItem';
import { MENU_ITEMS } from './config';

type Props = {
  className?: string;
};

export const Menu: React.FC<Props> = ({ className }) => {
  const { menu } = useLkLayoutStore();
  const { user } = userStore;
  const { logic } = useAppConfig();

  if (!user) {
    return null;
  }

  return (
    <Stack className={className}>
      <Stack gap={4}>
        {MENU_ITEMS.map((item) => {
          const label =
            item.sectionTitleKey && logic.sectionTitles[item.sectionTitleKey]
              ? logic.sectionTitles[item.sectionTitleKey]
              : item.label;

          return (
            item.showContentEditor && logic.showContentEditor.includes(item.showContentEditor)
              ? user.isContentEditor
              : item.roles.has(user.role)
          ) ? (
            <MenuItem key={item.to} {...item} label={label} collapsed={!menu.isOpen} />
          ) : null;
        })}
      </Stack>
    </Stack>
  );
};

export default observer(Menu);
